/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Ripia API
 * 美容サロン・リラクゼーション業界向け統合管理SaaSシステムAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateReservationDto,
  ReservationResponseDto,
  ReservationsControllerFindAllParams,
  ReservationsControllerGetAvailableTimeSlotsParams,
  ReservationsControllerGetReservationsByDateRangeParams,
  UpdateReservationDto,
  UpdateReservationStatusDto
} from '../../schemas';

import { customInstance } from '../../../lib/custom-instance';




/**
 * @summary 予約一覧取得（フィルタ可能）
 */
export const reservationsControllerFindAll = (
    params?: ReservationsControllerFindAllParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ReservationResponseDto[]>(
      {url: `/reservations`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getReservationsControllerFindAllQueryKey = (params?: ReservationsControllerFindAllParams,) => {
    return [
    `/reservations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReservationsControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof reservationsControllerFindAll>>, TError = unknown>(params?: ReservationsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindAll>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationsControllerFindAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationsControllerFindAll>>> = ({ signal }) => reservationsControllerFindAll(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationsControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof reservationsControllerFindAll>>>
export type ReservationsControllerFindAllQueryError = unknown


export function useReservationsControllerFindAll<TData = Awaited<ReturnType<typeof reservationsControllerFindAll>>, TError = unknown>(
 params: undefined |  ReservationsControllerFindAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof reservationsControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsControllerFindAll<TData = Awaited<ReturnType<typeof reservationsControllerFindAll>>, TError = unknown>(
 params?: ReservationsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof reservationsControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsControllerFindAll<TData = Awaited<ReturnType<typeof reservationsControllerFindAll>>, TError = unknown>(
 params?: ReservationsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 予約一覧取得（フィルタ可能）
 */

export function useReservationsControllerFindAll<TData = Awaited<ReturnType<typeof reservationsControllerFindAll>>, TError = unknown>(
 params?: ReservationsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationsControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 新規予約作成
 */
export const reservationsControllerCreate = (
    createReservationDto: CreateReservationDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ReservationResponseDto>(
      {url: `/reservations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createReservationDto, signal
    },
      );
    }
  


export const getReservationsControllerCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerCreate>>, TError,{data: CreateReservationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerCreate>>, TError,{data: CreateReservationDto}, TContext> => {

const mutationKey = ['reservationsControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationsControllerCreate>>, {data: CreateReservationDto}> = (props) => {
          const {data} = props ?? {};

          return  reservationsControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReservationsControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof reservationsControllerCreate>>>
    export type ReservationsControllerCreateMutationBody = CreateReservationDto
    export type ReservationsControllerCreateMutationError = void

    /**
 * @summary 新規予約作成
 */
export const useReservationsControllerCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerCreate>>, TError,{data: CreateReservationDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationsControllerCreate>>,
        TError,
        {data: CreateReservationDto},
        TContext
      > => {

      const mutationOptions = getReservationsControllerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 予約詳細取得
 */
export const reservationsControllerFindOne = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ReservationResponseDto>(
      {url: `/reservations/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getReservationsControllerFindOneQueryKey = (id?: string,) => {
    return [
    `/reservations/${id}`
    ] as const;
    }

    
export const getReservationsControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof reservationsControllerFindOne>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationsControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationsControllerFindOne>>> = ({ signal }) => reservationsControllerFindOne(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationsControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof reservationsControllerFindOne>>>
export type ReservationsControllerFindOneQueryError = void


export function useReservationsControllerFindOne<TData = Awaited<ReturnType<typeof reservationsControllerFindOne>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof reservationsControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsControllerFindOne<TData = Awaited<ReturnType<typeof reservationsControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof reservationsControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsControllerFindOne<TData = Awaited<ReturnType<typeof reservationsControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 予約詳細取得
 */

export function useReservationsControllerFindOne<TData = Awaited<ReturnType<typeof reservationsControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationsControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 予約更新
 */
export const reservationsControllerUpdate = (
    id: string,
    updateReservationDto: UpdateReservationDto,
 ) => {
      
      
      return customInstance<void>(
      {url: `/reservations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateReservationDto
    },
      );
    }
  


export const getReservationsControllerUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerUpdate>>, TError,{id: string;data: UpdateReservationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerUpdate>>, TError,{id: string;data: UpdateReservationDto}, TContext> => {

const mutationKey = ['reservationsControllerUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationsControllerUpdate>>, {id: string;data: UpdateReservationDto}> = (props) => {
          const {id,data} = props ?? {};

          return  reservationsControllerUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReservationsControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof reservationsControllerUpdate>>>
    export type ReservationsControllerUpdateMutationBody = UpdateReservationDto
    export type ReservationsControllerUpdateMutationError = void

    /**
 * @summary 予約更新
 */
export const useReservationsControllerUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerUpdate>>, TError,{id: string;data: UpdateReservationDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationsControllerUpdate>>,
        TError,
        {id: string;data: UpdateReservationDto},
        TContext
      > => {

      const mutationOptions = getReservationsControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 予約削除（論理削除）
 */
export const reservationsControllerRemove = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/reservations/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getReservationsControllerRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerRemove>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['reservationsControllerRemove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationsControllerRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  reservationsControllerRemove(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReservationsControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof reservationsControllerRemove>>>
    
    export type ReservationsControllerRemoveMutationError = void

    /**
 * @summary 予約削除（論理削除）
 */
export const useReservationsControllerRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerRemove>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationsControllerRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getReservationsControllerRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 予約ステータス更新
 */
export const reservationsControllerUpdateStatus = (
    id: string,
    updateReservationStatusDto: UpdateReservationStatusDto,
 ) => {
      
      
      return customInstance<void>(
      {url: `/reservations/${id}/status`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateReservationStatusDto
    },
      );
    }
  


export const getReservationsControllerUpdateStatusMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerUpdateStatus>>, TError,{id: string;data: UpdateReservationStatusDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerUpdateStatus>>, TError,{id: string;data: UpdateReservationStatusDto}, TContext> => {

const mutationKey = ['reservationsControllerUpdateStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationsControllerUpdateStatus>>, {id: string;data: UpdateReservationStatusDto}> = (props) => {
          const {id,data} = props ?? {};

          return  reservationsControllerUpdateStatus(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReservationsControllerUpdateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof reservationsControllerUpdateStatus>>>
    export type ReservationsControllerUpdateStatusMutationBody = UpdateReservationStatusDto
    export type ReservationsControllerUpdateStatusMutationError = void

    /**
 * @summary 予約ステータス更新
 */
export const useReservationsControllerUpdateStatus = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerUpdateStatus>>, TError,{id: string;data: UpdateReservationStatusDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationsControllerUpdateStatus>>,
        TError,
        {id: string;data: UpdateReservationStatusDto},
        TContext
      > => {

      const mutationOptions = getReservationsControllerUpdateStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 来店済み処理（施術記録化 + 完了遷移）
 */
export const reservationsControllerCompleteVisit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/reservations/${id}/complete-visit`, method: 'POST', signal
    },
      );
    }
  


export const getReservationsControllerCompleteVisitMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerCompleteVisit>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerCompleteVisit>>, TError,{id: string}, TContext> => {

const mutationKey = ['reservationsControllerCompleteVisit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationsControllerCompleteVisit>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  reservationsControllerCompleteVisit(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReservationsControllerCompleteVisitMutationResult = NonNullable<Awaited<ReturnType<typeof reservationsControllerCompleteVisit>>>
    
    export type ReservationsControllerCompleteVisitMutationError = void

    /**
 * @summary 来店済み処理（施術記録化 + 完了遷移）
 */
export const useReservationsControllerCompleteVisit = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerCompleteVisit>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationsControllerCompleteVisit>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getReservationsControllerCompleteVisitMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 予約キャンセル
 */
export const reservationsControllerCancel = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/reservations/${id}/cancel`, method: 'PATCH'
    },
      );
    }
  


export const getReservationsControllerCancelMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerCancel>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerCancel>>, TError,{id: string}, TContext> => {

const mutationKey = ['reservationsControllerCancel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationsControllerCancel>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  reservationsControllerCancel(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReservationsControllerCancelMutationResult = NonNullable<Awaited<ReturnType<typeof reservationsControllerCancel>>>
    
    export type ReservationsControllerCancelMutationError = void

    /**
 * @summary 予約キャンセル
 */
export const useReservationsControllerCancel = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsControllerCancel>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationsControllerCancel>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getReservationsControllerCancelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary スタッフの空き予約枠取得
 */
export const reservationsControllerGetAvailableTimeSlots = (
    staffId: string,
    params: ReservationsControllerGetAvailableTimeSlotsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/reservations/staff/${staffId}/available-slots`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getReservationsControllerGetAvailableTimeSlotsQueryKey = (staffId?: string,
    params?: ReservationsControllerGetAvailableTimeSlotsParams,) => {
    return [
    `/reservations/staff/${staffId}/available-slots`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReservationsControllerGetAvailableTimeSlotsQueryOptions = <TData = Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>, TError = unknown>(staffId: string,
    params: ReservationsControllerGetAvailableTimeSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationsControllerGetAvailableTimeSlotsQueryKey(staffId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>> = ({ signal }) => reservationsControllerGetAvailableTimeSlots(staffId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(staffId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationsControllerGetAvailableTimeSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>>
export type ReservationsControllerGetAvailableTimeSlotsQueryError = unknown


export function useReservationsControllerGetAvailableTimeSlots<TData = Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>, TError = unknown>(
 staffId: string,
    params: ReservationsControllerGetAvailableTimeSlotsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>,
          TError,
          Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsControllerGetAvailableTimeSlots<TData = Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>, TError = unknown>(
 staffId: string,
    params: ReservationsControllerGetAvailableTimeSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>,
          TError,
          Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsControllerGetAvailableTimeSlots<TData = Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>, TError = unknown>(
 staffId: string,
    params: ReservationsControllerGetAvailableTimeSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary スタッフの空き予約枠取得
 */

export function useReservationsControllerGetAvailableTimeSlots<TData = Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>, TError = unknown>(
 staffId: string,
    params: ReservationsControllerGetAvailableTimeSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetAvailableTimeSlots>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationsControllerGetAvailableTimeSlotsQueryOptions(staffId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 顧客の今後の予約取得
 */
export const reservationsControllerGetUpcomingReservations = (
    customerId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/reservations/customer/${customerId}/upcoming`, method: 'GET', signal
    },
      );
    }
  



export const getReservationsControllerGetUpcomingReservationsQueryKey = (customerId?: string,) => {
    return [
    `/reservations/customer/${customerId}/upcoming`
    ] as const;
    }

    
export const getReservationsControllerGetUpcomingReservationsQueryOptions = <TData = Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>, TError = unknown>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationsControllerGetUpcomingReservationsQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>> = ({ signal }) => reservationsControllerGetUpcomingReservations(customerId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationsControllerGetUpcomingReservationsQueryResult = NonNullable<Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>>
export type ReservationsControllerGetUpcomingReservationsQueryError = unknown


export function useReservationsControllerGetUpcomingReservations<TData = Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>, TError = unknown>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>,
          TError,
          Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsControllerGetUpcomingReservations<TData = Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>,
          TError,
          Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsControllerGetUpcomingReservations<TData = Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 顧客の今後の予約取得
 */

export function useReservationsControllerGetUpcomingReservations<TData = Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetUpcomingReservations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationsControllerGetUpcomingReservationsQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 期間指定で予約取得
 */
export const reservationsControllerGetReservationsByDateRange = (
    params: ReservationsControllerGetReservationsByDateRangeParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/reservations/date-range`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getReservationsControllerGetReservationsByDateRangeQueryKey = (params?: ReservationsControllerGetReservationsByDateRangeParams,) => {
    return [
    `/reservations/date-range`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReservationsControllerGetReservationsByDateRangeQueryOptions = <TData = Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>, TError = unknown>(params: ReservationsControllerGetReservationsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationsControllerGetReservationsByDateRangeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>> = ({ signal }) => reservationsControllerGetReservationsByDateRange(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationsControllerGetReservationsByDateRangeQueryResult = NonNullable<Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>>
export type ReservationsControllerGetReservationsByDateRangeQueryError = unknown


export function useReservationsControllerGetReservationsByDateRange<TData = Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>, TError = unknown>(
 params: ReservationsControllerGetReservationsByDateRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>,
          TError,
          Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsControllerGetReservationsByDateRange<TData = Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>, TError = unknown>(
 params: ReservationsControllerGetReservationsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>,
          TError,
          Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsControllerGetReservationsByDateRange<TData = Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>, TError = unknown>(
 params: ReservationsControllerGetReservationsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 期間指定で予約取得
 */

export function useReservationsControllerGetReservationsByDateRange<TData = Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>, TError = unknown>(
 params: ReservationsControllerGetReservationsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsControllerGetReservationsByDateRange>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationsControllerGetReservationsByDateRangeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




